import { Dialog, type DialogProps, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'
import * as tkn from './Modal.tokens'

export type TModalSize = 's' | 'm' | 'l' | 'xl' | 'xxl' | 'settings' | 'upsell'
export type TModalPlacement = 'center' | 'top'
export interface IModalProps {
  size?: TModalSize
  placement?: TModalPlacement
}

const SIZES: Record<TModalSize, string> = {
  s: tkn.ModalSizeWidthSmall,
  m: tkn.ModalSizeWidthMedium,
  l: tkn.ModalSizeWidthLarge,
  xl: tkn.ModalSizeWidthXlarge,
  xxl: '1440px',
  settings: '1048px',
  upsell: '886px',
}

interface IStyledModalProps extends DialogProps {
  placement?: IModalProps['placement']
}

export const Modal = styled(Dialog, {
  shouldForwardProp: youShallNotPass('placement', 'size'),
})<IStyledModalProps>(({ placement, theme }) => ({
  zIndex: theme.zIndexes.dialog,
  '& .MuiBackdrop-root': {
    background: 'rgba(0, 0, 0, 0.3)',
  },
  '& .MuiDialog-container': {
    ...(placement === 'top' && {
      alignItems: 'flex-start',
    }),
  },
}))

interface IModalPaperProps {
  size: IModalProps['size']
  fullScreen?: DialogProps['fullScreen']
  placement?: IModalProps['placement']
}

export const ModalPaper = styled(Paper, {
  shouldForwardProp: youShallNotPass('size', 'fullScreen', 'placement'),
})<IModalPaperProps>(({ size, fullScreen, placement, theme }) => ({
  '&&': {
    ...(!fullScreen && {
      width: size && SIZES[size],
      maxWidth: size && SIZES[size],
    }),
    ...(fullScreen && {
      margin: theme.spacing(1),
      maxHeight: 'calc(100% - 16px)',
    }),
    background: tkn.ModalColorSurface,
    borderRadius: tkn.ModalBorderRadiusContainer,
    ...(placement === 'top' && {
      alignSelf: 'flex-start', // for cases where custom TransitionComponent is provided
    }),
  },
  '@media (max-height:700px)': {
    marginTop: '8px',
    marginBottom: '8px',
    maxHeight: 'calc(100% - 16px)',
  },
}))
